export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref12002.c8db0cc1.jpg";